import React from 'react';
import { createRoot } from 'react-dom/client';

import WebinarsApp from 'webinars';
import BravelyData from 'utils/data';

const node = document.querySelector('#webinars-app-container');
const root = createRoot(node);
const webinarData = BravelyData('webinarData') || {};

root.render(<WebinarsApp webinar={webinarData} />);
